import {
  Heading,
  Table,
  TableContainer,
  Tag,
  TagLabel,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import useApiRequest from "hooks/api/useApiHook";
import { FC } from "react";
import { formatDate } from "utils/conversion/formatTime";
import { formatUsd } from "./helpers";

type Props = {
  apiToken: string;
  // Bumped by the parent after a payout request so the list re-fetches.
  refreshKey: number;
};

const statusColor = (status: string): string => {
  switch (status) {
    case "paid":
      return "green";
    case "rejected":
      return "red";
    case "pending":
    default:
      return "yellow";
  }
};

// The caller's payout requests, newest first (server already orders by id DESC).
const PayoutHistory: FC<Props> = ({ apiToken, refreshKey }) => {
  const { data } = useApiRequest(
    {
      apiToken,
      method: RequestMethod.GET,
      name: RequestName.REFERRAL_PAYOUTS,
    },
    null,
    refreshKey
  );

  const payouts: any[] = Array.isArray(data?.payouts) ? data.payouts : [];

  if (!payouts.length) return null;

  return (
    <BoxShadowContainer>
      <Heading as="h3" size="sm" mb={4}>
        Payout requests
      </Heading>
      <TableContainer maxHeight="400px" overflowY="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Date</Th>
              <Th>Currency</Th>
              <Th>Gross</Th>
              <Th>Fee</Th>
              <Th>Net</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {payouts.map((p) => (
              <Tr key={p.id}>
                <Td>{formatDate(p.created_at)}</Td>
                <Td>{p.currency}</Td>
                <Td>{formatUsd(p.amount_usd)} $</Td>
                <Td>{formatUsd(p.fee_usd)} $</Td>
                <Td>{formatUsd(p.net_usd)} $</Td>
                <Td>
                  <Tag size="md" variant="solid" colorScheme={statusColor(p.status)}>
                    <TagLabel>{p.status}</TagLabel>
                  </Tag>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </BoxShadowContainer>
  );
};

export default PayoutHistory;
